import {
  // HomeDemo5Platforms1,
  // HomeDemo5Platforms2,
  // HomeDemo5Platforms3,
  // HomeDemo5Platforms4,
  // HomeDemo5Platforms5,
  // HomeDemo5Platforms6,
  HomeDemo5FeaturesS1,
  HomeDemo5FeaturesS2,
  HomeDemo5FeaturesS3,
  HomeDemo5FeaturesS4,
  HomeDemo5FeaturesF1,
  HomeDemo5FeaturesF2,
  HomeDemo5FeaturesF3,
  HomeDemo5FeaturesF4,
  HomeDemo5FeaturesF5,
  HomeDemo5FeaturesF6,
  HomeDemo5TeamImg1,
  HomeDemo5TeamImg2,
  HomeDemo5TeamImg3,
  HomeDemo5TeamImg4,
  HomeDemo5Feature1,
  HomeDemo5Feature2,
  HomeDemo5Feature3,
  HomeDemo5Feature4,
  HomeDemo5Feature5,
  HomeDemo5Feature6,
  HomeDemo5Feature7,
  HomeDemo5Feature8,
} from "../../../utils/allImgs";
// import { useTranslation } from "react-i18next";

// export const SecTrustContent = [
//   {
//     img: HomeDemo5Platforms1,
//     CheckIcon: true,
//   },
//   {
//     img: HomeDemo5Platforms2,
//     value: 8.9,
//     CheckIcon: false,
//   },
//   {
//     img: HomeDemo5Platforms3,
//     CheckIcon: true,
//   },
//   {
//     img: HomeDemo5Platforms4,
//     CheckIcon: true,
//   },
//   {
//     img: HomeDemo5Platforms5,
//     value: 7.4,
//     CheckIcon: false,
//   },
//   {
//     img: HomeDemo5Platforms6,
//     CheckIcon: true,
//   },
// ];
// const { t } = useTranslation();

export const TokenFeaturesTop = [
  {
    img: HomeDemo5FeaturesF1,
    title: "Delivery Reports",
  },
  {
    img: HomeDemo5FeaturesF2,
    title: "Branded Sender ID",
  },
];

export const TokenFeaturesMed = [
  {
    img: HomeDemo5FeaturesF3,
    title: "Marketing Campigns",
  },
  {
    img: HomeDemo5FeaturesF4,
    title: "professional Routing",
  },
];

export const Services = [
  {
    img: HomeDemo5Feature1,
    title: "WEBSITE/ MOBILE DEVELOPMENT",
    info: "in ITS Computing we have developing talent and effective teams provide everything that the client needs to design and develop the website, mobile app and digital platforms in accordance with the highest international standards to ensure the security and protection of Data",
  },
  {
    img: HomeDemo5Feature2,
    title: "HOSTING SOLUTION",
    info: "In ITS Computing we provide hosting solution at the lowest costs by using cloud servers with fast response, high reliability and security We also provide 24-hour support team to ensure the continuation of your business efficiently",
  },
  {
    img: HomeDemo5Feature3,
    title: "ARTIFICIAL INTELLIGENCE APPLICATION",
    info: "In ITS Computing we have a scientific and technical team that can upgrade your business into deep learning and artificial intelligence algorithms that can perform complex and intelligent functions related to human thinking and more",
  },
  {
    img: HomeDemo5Feature4,
    title: "TECHNOLOGY R&D",
    info: "In ITS Computing believe in the importance of scientific research and development, innovation and transformation into a knowledge economy based on information and communication technology",
  },
  {
    img: HomeDemo5Feature5,
    title: "DESIGNS & BRANDING",
    info: "In ITS Computing Design branding and visual identity for the business sector in order to achieve the highest competitive advantage",
  },
  {
    img: HomeDemo5Feature6,
    title: "STARTUP SME APPLICATION MANAGEMENT",
    info: "The important thing is not to establish a startup, but rather for this company to succeed and succeed, and we will try in ITS Computing to support SME and entrepreneurs through information technology",
  },
  {
    img: HomeDemo5Feature7,
    title: "TECHNOLOGY TRAINING & WORKSHOP",
    info: "In ITS Computing we have a specialized professional team that provides quality training courses in the fields of emerging technologies with the aim of raising professional capabilities and understanding the basics in the field of emerging technology and its uses in daily life",
  },
  {
    img: HomeDemo5Feature8,
    title: "SHARING ECONOMY P2P TECHNOLOGY",
    info: "In ITS Computing support to develop sharing economy is an economic model defined as a peer-to-peer (P2P) based activity of acquiring, providing, or sharing access to goods and services that is often facilitated by a community-based on-line platform",
  },
];

export const TokenFeaturesDown = [
  {
    img: HomeDemo5FeaturesF5,
    title: "Traking API",
  },
  {
    img: HomeDemo5FeaturesF6,
    title: "Two-Way Messaging",
  },
];

export const SmartContractinfo = [
  {
    img: HomeDemo5FeaturesS1,
    title: "Cycles and schedules",
  },
  {
    img: HomeDemo5FeaturesS2,
    title: "Advanced application interface (API)",
  },
  {
    img: HomeDemo5FeaturesS3,
    title: "Software development kit (SDK)",
  },
  {
    img: HomeDemo5FeaturesS4,
    title: "Java virtual machine (JVM)",
  },
];

export const OurTeamInfo = [
  {
    img: HomeDemo5TeamImg1,
    title: "Dr. Rayan Nouh",
    text: "Founder",
  },
  {
    img: HomeDemo5TeamImg2,
    title: "Syed Shanu",
    text: "Microsoft MVP Technical Consultation",
  },
  {
    img: HomeDemo5TeamImg3,
    title: "Jalal Maqboul PhD",
    text: "IT Business Analytics",
  },
  {
    img: HomeDemo5TeamImg4,
    title: "Ragheed Samkari",
    text: "Front End Developer",
  },
];
